import React, { useContext, useMemo } from 'react';
import flatten from 'lodash/flatten';

import ListStateContext from 'logview/components/contexts/ListStateContext';
import type { LogViewMessage } from 'logview/types';
import SelectableEntitiesContext from 'logview/components/contexts/SelectableLogViewMessagesContext';
import useLogViewLayout from 'logview/hooks/useLogViewLayout';

const defaultIsEntitySelectable = () => true;
const SelectableLogViewMessagesProvider = ({
  children = null,
  isEntitySelectable = defaultIsEntitySelectable,
  displayBulkSelectCol = false,
}: React.PropsWithChildren<{
  displayBulkSelectCol?: boolean;
  isEntitySelectable?: (message: LogViewMessage) => boolean;
}>) => {
  const { allLoadedPages } = useContext(ListStateContext);
  const { timestampField } = useLogViewLayout();
  const contextValues = useMemo(() => {
    if (!displayBulkSelectCol) return { selectableLogViewMessages: [] };

    return {
      selectableLogViewMessages: flatten(Object.values(allLoadedPages))
        .filter(isEntitySelectable)
        .map(({ frontendId, message }: LogViewMessage) => ({
          id: frontendId,
          timestamp: message[timestampField],
        })),
    };
  }, [allLoadedPages, displayBulkSelectCol, isEntitySelectable, timestampField]);

  return <SelectableEntitiesContext.Provider value={contextValues}>{children}</SelectableEntitiesContext.Provider>;
};

export default SelectableLogViewMessagesProvider;
